import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { fileUpload } from '../helpers/fileUpload';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const getAlbumList = (albumId) => {
    const url = `${URL_BASE_API}/api/album/getalbumlist`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const getAlbumListApproval = (startDate, endDate, statusId, album, song, artist) => {
    const url = `${URL_BASE_API}/api/album/getalbumlistapproval`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: startDate,
            field03: endDate,
            field04: statusId?.toString(),
            field05: album,
            field06: song,
            field07: artist,
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const saveAlbum = (albumId, title, launchingDate, creator, producer, isAlbum) => {
    const url = `${URL_BASE_API}/api/album/save`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: title,
            field04: launchingDate,
            field05: creator,
            field06: producer,
            field07: isAlbum.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const uploadAlbumImage = (file, albumId) => {
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const url = `${URL_BASE_API}/api/album/changealbumimage/${userId}/${albumId?.toString()}`;
    const data = new FormData();
    data.append('asset', file);

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fileUpload(url, data, config);

    return rsp;
}


export const getAlbumArtistList = (albumId, albumArtistId) => {
    const url = `${URL_BASE_API}/api/album/getalbumartistlist`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: albumArtistId?.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const addAlbumArtist = (albumArtistId, albumId, nameArtist, type, urlSpotify, urlApple, urlTiktok, urlYoutube, urlInstagram, urlFacebook, prctParticipation) => {
    const url = `${URL_BASE_API}/api/album/addartist`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: albumArtistId ? albumArtistId?.toString() : '-1',
            field04: nameArtist,
            field05: type,
            field06: urlSpotify,
            field07: urlApple,
            field08: urlTiktok,
            field09: urlYoutube,
            field10: urlInstagram,
            field11: urlFacebook,
            field12: prctParticipation.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const getAlbumSongList = (albumId) => {
    const url = `${URL_BASE_API}/api/album/getalbumsongslist`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const addAlbumSong = (albumId, nameSong, lyricsFile, audioFile) => {
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    
    const url = `${URL_BASE_API}/api/album/addalbumsong/${userId}/${albumId}/${nameSong}/${language}`;
    const data = new FormData();
    
    if (lyricsFile!==null){
        data.append('assetLyrics', lyricsFile);
    }
    
    data.append('assetAudio', audioFile);

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`
        }
    };
    
    const rsp = fileUpload(url, data, config);
    return rsp;
}


export const deleteAlbumArtist = (albumId, albumArtistId) => {
    const url = `${URL_BASE_API}/api/album/deletealbumartist`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: albumArtistId ? albumArtistId.toString() : '-1',
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const deleteAlbumSong = (albumId, songId) => {
    const url = `${URL_BASE_API}/api/album/deletealbumsong`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: songId ? songId?.toString() : '-1',
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const deleteAlbum = (albumId) => {
    const url = `${URL_BASE_API}/api/album/deletealbum`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const publishAlbum = (albumId) => {
    const url = `${URL_BASE_API}/api/album/publishalbum`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            lang: language
        }, 
        config
    );
    
    return rsp;
}


export const evalAlbum = (albumId, action, comments) => {
    const url = `${URL_BASE_API}/api/album/evalalbum`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
        
    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: action,
            field04: comments,
            lang: language
        },
        config
    );
    
    return rsp;
}



export const getChatAlbum = (albumId) => {
    const url = `${URL_BASE_API}/api/album/getchatalbum`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
        
    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            lang: language
        },
        config
    );
    
    return rsp;
}



export const sendMessageChatAlbum = (albumId, message) => {
    const url = `${URL_BASE_API}/api/album/sendmessagechatalbum`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
        
    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: albumId?.toString(),
            field03: message,
            lang: language
        },
        config
    );
    
    return rsp;
}
